import type { CSSProperties } from 'react'
import React from 'react'
import { colors } from '@fs/zion-ui'
import { Elevation } from '@fs/zion-ui/quarks-authorized-use-only'
import { PlaceTemple } from '@fs/zion-icon'
import { css } from '@emotion/core'

const iconCss = css`
  border-radius: 100%;
  width: 28px;
  height: 28px;
  background: var(--button-background);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  inset-inline-end: 0;
`

export default ({
  color,
  background,
  style,
  hasTimer,
}: {
  color?: string
  background?: string
  style?: CSSProperties
  hasTimer?: boolean
}): JSX.Element => (
  <div
    data-testid="temple-icon"
    css={iconCss}
    style={{
      color: color ?? colors.gray00,
      '--button-background': background ?? colors.green30,
      ...(style ?? {}),
    }}
  >
    <PlaceTemple size="xs" />
    {hasTimer && <TempleTimerIcon style={{ top: -3, insetInlineEnd: -3, position: 'absolute' }} />}
  </div>
)

export function TempleTimerIcon({ style }: { style: CSSProperties }): JSX.Element {
  return (
    <Elevation
      z={6}
      style={{ borderRadius: '100%', width: 14, height: 14, background: 'var(--button-background)', ...style }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <circle cy="7" cx="7" r="5" fill="var(--button-background)" strokeWidth={1.5} stroke="currentcolor" />
        <path d="M7 4 L7 7.5 L9.5 8.5" stroke="currentcolor" strokeWidth={1.5} />
      </svg>
    </Elevation>
  )
}
